import React from "react";
import { Typography } from "@mui/material";

const clock = (date) => date.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });

/**
 * Says what auto-save is doing: saving, saved (and when), or failed. Renders nothing before the first change, so an
 * editor that has not been touched stays quiet.
 */
export default function AutoSaveStatus({ status, savedAt, error, published = false }) {
  if (published) {
    return (
      <Typography component="span" role="status" sx={{ fontSize: "12.5px", color: "text.secondary" }}>
        Live items are not auto-saved. Press Save Changes to update them.
      </Typography>
    );
  }
  if (status === "idle") return null;
  if (status === "saving") {
    return <Typography component="span" role="status" sx={{ fontSize: "12.5px", color: "text.secondary" }}>Saving…</Typography>;
  }
  if (status === "error") {
    return (
      <Typography component="span" role="alert" sx={{ fontSize: "12.5px", color: "error.main" }}>
        Not saved yet. {error} Your changes are still here; they will try again when you edit.
      </Typography>
    );
  }
  return (
    <Typography component="span" role="status" sx={{ fontSize: "12.5px", color: "success.dark" }}>
      Saved{savedAt ? ` at ${clock(savedAt)}` : ""}
    </Typography>
  );
}
